// Libraries
var React = require('react');

// Components
var Loader = require('../../common/Loader/Loader');

// Styles
require('./VideoEmbedStream.scss');
require('../../css/utilities.scss');

class EndeavorVideoChromecast extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			session: null,
			isCasting: false,
			isAvailable: false,
			isConnecting: false,
			isPaused: false,
			currentTime: 0
		};
	}

	componentDidMount() {
		if(window.__chromecastLoaded === undefined) {
			this.loadApi();
		} else {
			this.setupButton();
		}	
	}

	loadApi() {
		const script = document.createElement("script");
		script.src = "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
		script.onload = () => {
			window.__chromecastLoaded = true;
			this.setupButton();
		}
		document.head.appendChild(script);
	}

	setupButton() {
		var loadCastInterval = setInterval(()=>{
			if (window.chrome.cast.isAvailable) {
					clearInterval(loadCastInterval);
					this.setState({
						isAvailable: true
					});
					this.initializeCastApi();
			} else {
				this.setState({
					isAvailable: false
				});
			}
		}, 1000);
	}

	initializeCastApi() {
		window.cast.framework.CastContext.getInstance().setOptions({
			receiverApplicationId: window.chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
			autoJoinPolicy: window.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
  			resumeSavedSession: true
		});
	}

	connect() {
		return Promise.resolve()
		.then(() => {
		  var castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();
		  if (!castSession) {
			return window.cast.framework.CastContext.getInstance().requestSession()
			.then(() => {
			  	return Promise.resolve(window.cast.framework.CastContext.getInstance().getCurrentSession());
			});
		  }
		  return Promise.resolve(castSession);
		});
	}

	launchApp() {

		this.setState({
			isConnecting: true
		});

		this.props.handleCasting();

		return Promise.all([this.connect(), this.props.requestVideoDetails()])
		.then(([session, videoDetails])=> {
			var videoSrc = videoDetails.hlsUrl;
			var mediaInfo = new window.chrome.cast.media.MediaInfo(videoSrc);
			mediaInfo.contentType = 'application/x-mpegURL';
			var subtitles = this.loadTracks(videoDetails);
			if(subtitles.length) {
				mediaInfo.tracks = subtitles;
			}
			var request = new window.chrome.cast.media.LoadRequest(mediaInfo);
			request.autoplay = true;
			request.currentTime = this.props.getVideoPlayer().currentTime;
			return session.loadMedia(request);
		})
		.then(()=> { 
			this.setState({
				isCasting: true,
				isConnecting: false
			});
			this.listenToRemote();
		})
		.catch((error)=> {
			this.setState({
				isCasting: false,
				isConnecting: false
			});
			console.log(error);
			this.props.handleStopCasting(0);
		});
	}

	loadTracks(videoDetails) {

		var tracks = [];

		for (var index = 0; index < videoDetails.subtitles.length; index++) {
			var currentSubtitle = videoDetails.subtitles[index];
			var subtitle = new window.chrome.cast.media.Track(index + 1, window.chrome.cast.media.TrackType.TEXT);
			subtitle.trackContentId = currentSubtitle.url;
			subtitle.trackContentType = 'text/' + currentSubtitle.url.split('.')[1];
			subtitle.subtype = window.chrome.cast.media.TextTrackType.SUBTITLES;
			subtitle.name = currentSubtitle.lang;
			subtitle.language = currentSubtitle.lang;
			subtitle.customData = null;
		}

		return tracks;

	}

	listenToRemote() {
		var player = new window.cast.framework.RemotePlayer();
		var playerController = new window.cast.framework.RemotePlayerController(player);

		playerController.addEventListener(
		window.cast.framework.RemotePlayerEventType.ANY_CHANGE,
		(event)=> {
			this.setState({
				isPaused: player.isPaused,
				currentTime: player.currentTime
			});
		});

		playerController.addEventListener(
		window.cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED, ()=> {
			if (!player.isConnected) {
				this.stopApp();
			}
		});
	}

	stopApp() {
		var castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();
		if(castSession) {
			castSession.endSession(true);
		}
		this.setState({
			isConnecting: false,
			isCasting: false
		});
		this.props.handleStopCasting(this.state.currentTime);
	}

	togglePlayPause() {
		var player = new window.cast.framework.RemotePlayer();
		var playerController = new window.cast.framework.RemotePlayerController(player);
		playerController.playOrPause();
	}

    render() {
		return (
			<React.Fragment>
				{this.state.isAvailable ?
					<button type="button" className="VideoEmbedStream__chromecast" onClick={this.launchApp.bind(this)}>
						<svg width={40} height={40} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="VideoEmbedStream__chromecast-cast-icon">
							<path d="M 6 6 C 4.897 6 4 6.897 4 8 L 4 12 L 6 12 L 6 8 L 26 8 L 26 24 L 18 24 L 18 26 L 26 26 C 27.103 26 28 25.103 28 24 L 28 8 C 28 6.897 27.103 6 26 6 L 6 6 z M 4 14 L 4 16 C 9.169375 16 13.436179 19.942273 13.949219 24.978516 C 13.983421 25.314265 14 25.655375 14 26 L 16 26 C 16 19.383 10.617 14 4 14 z M 4 18 L 4 20 C 7.309 20 10 22.691 10 26 L 12 26 C 12 21.589 8.411 18 4 18 z M 4 22 L 4 26 L 8 26 C 8 23.791 6.209 22 4 22 z" fill="#FFF"></path>
						</svg>
						<span className='u-visually-hidden'>Cast video to Chromecast</span>
					</button>
				: null }
				{this.state.isConnecting ?
					<div className="VideoEmbedStream__chromecast-overlay">				
						<p className="VideoEmbedStream__chromecast-message"><Loader inline /> Connecting to Chromecast...</p>
					</div>
				: null}	
				{this.state.isCasting ?
					<div className="VideoEmbedStream__chromecast-overlay">
						<p className="VideoEmbedStream__chromecast-message">Playing on Chromecast</p>
						<div>
							{this.state.isPaused ? 
							<button type="button" className="VideoEmbedStream__chromecast-button" onClick={this.togglePlayPause.bind(this)}>
								<svg viewBox="0 0 32 32" width={32} height={32}>
									<path d="M6 4l20 12-20 12z" fill="currentColor"></path>
								</svg>
								<span className='u-visually-hidden'>Play video</span>
							</button>
							: 
							<button type="button" className="VideoEmbedStream__chromecast-button" onClick={this.togglePlayPause.bind(this)}>
								<svg viewBox="0 0 32 32" width={32} height={32}>
									<path d="M4 4h10v24h-10zM18 4h10v24h-10z" fill="currentColor"></path>
								</svg>
								<span className='u-visually-hidden'>Pause video</span>
							</button>
							}
							<button type="button" className="VideoEmbedStream__chromecast-button" onClick={this.stopApp.bind(this)}>
								<svg viewBox="0 0 32 32" width={32} height={32}>
									<path d="M4 4h24v24h-24z" fill="currentColor"></path>
								</svg>
								<span className='u-visually-hidden'>Stop casting video</span>
							</button>
						</div>
					</div>
				: null}		
			</React.Fragment>
		)
	}


}

module.exports = EndeavorVideoChromecast;


// WEBPACK FOOTER //
// ./src/components/Video/EndeavorVideoChromecast.js